const MEDIA = [
  {
    title: '《星际穿越2》终极预告',
    desc: '诺兰回归科幻巅峰之作，穿越虫洞探索未知宇宙',
    duration: '02:48',
    views: '89万次观看',
    icon: 'ri-play-circle-fill',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20space%20scene%20with%20wormhole%20and%20starship%20dramatic%20lighting%20cosmic%20atmosphere%20cinematic%20composition&width=640&height=360&seq=media-1-2026&orientation=landscape',
  },
  {
    title: '花生影院使用指南',
    desc: '3分钟带你玩转花生影院所有功能，发现更多好片',
    duration: '03:15',
    views: '46万次观看',
    icon: 'ri-guide-fill',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Modern%20clean%20tutorial%20screen%20showing%20movie%20streaming%20platform%20interface%20guide%20with%20warm%20friendly%20design%20and%20organized%20layout&width=640&height=360&seq=media-2-2026&orientation=landscape',
  },
  {
    title: '2026暑期档观影指南',
    desc: '今年夏天最值得期待的十部电影，一部都不能错过',
    duration: '04:30',
    views: '72万次观看',
    icon: 'ri-calendar-event-fill',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Colorful%20summer%20movie%20collage%20with%20multiple%20film%20genre%20posters%20arranged%20artistically%20vibrant%20warm%20tones%20cinematic%20collection&width=640&height=360&seq=media-3-2026&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            精彩预告
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            热门电影预告片与平台精彩内容，先睹为快
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {MEDIA.map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-background-100 border border-secondary-100/60 hover:border-secondary-300/60 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-secondary-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-background-50/90 group-hover:bg-background-50 transition-colors shadow-lg">
                    <i className="ri-play-fill text-2xl md:text-3xl text-primary-600 ml-1"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 bg-black/70 text-background-50 text-xs px-2 py-1 rounded">
                  {item.duration}
                </div>
              </div>

              <div className="p-4 md:p-5">
                <div className="flex items-start gap-2 mb-2">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-primary-500 text-lg`}></i>
                  </div>
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 leading-snug">
                    {item.title}
                  </h3>
                </div>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3 ml-10">
                  {item.desc}
                </p>
                <div className="ml-10 text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  <span>{item.views}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}